export enum OperationalFileStatus {
    Active = 0,
    Cancelled = 1,
    Closed = 2,
}